'use client'

import React, { useEffect } from 'react'
import Overlay from '@dustin-web/microsite-components/src/overlay'
import {
  DesktopStateActionType,
  useHeaderContext,
} from '@dustin-web/microsite-baselayout/src/components/header/header-context'
import { getLayerClassName } from '@dustin-web/microsite-components/src/utils/get-layer-class-name'

const AppHeaderDesktopEffects = ({ children }: { children: React.ReactNode }) => {
  const { desktop, dispatchDesktop } = useHeaderContext()

  // Close all active menus on Escape
  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.code === 'Escape') {
        const element = e.target as HTMLElement | undefined
        element?.blur()
        dispatchDesktop({
          type: DesktopStateActionType.CLOSE_ALL_MENUS,
        })
      }
    }
    document.addEventListener('keyup', handleKeyUp)
    return () => {
      document.removeEventListener('keyup', handleKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const showOverlay = desktop.activeMegaMenu.length > 0 || desktop.activeMenus.includes('search')

  return (
    <>
      {showOverlay && <Overlay show={showOverlay} className={getLayerClassName('dialog')} />}
      {children}
    </>
  )
}

export default AppHeaderDesktopEffects
